import {detectDevice, DeviceMobile} from '@treatwell/ui';
import {GTM_ID} from './gtmTracking';
import {AvailabilityApiResponseChannel} from '../../server/routes/availability/types';
import {GtmPayLoad} from '../../shared/types';

type DesktopView = 'STANDARD';
type MobileView = 'MOBILE';
type View = DesktopView | MobileView;
type PlatformCode = `${DesktopView}-WEB` | `${MobileView}-WEB`;

const isMobile = detectDevice(navigator.userAgent).type === DeviceMobile;
const view: View = isMobile ? 'MOBILE' : 'STANDARD';
const platformCode: PlatformCode = isMobile ? 'MOBILE-WEB' : 'STANDARD-WEB';

export const reschedulePageType = 'reschedule';
export const availabilityPageType = 'availability';

export const createPageData = ({
  channel,
  environment,
  venueId,
  pageType,
}: {
  channel: AvailabilityApiResponseChannel;
  environment: string;
  venueId: number | null;
  pageType: typeof reschedulePageType | typeof availabilityPageType;
}): GtmPayLoad => {
  let type = '';
  if (pageType === reschedulePageType) {
    type = 'datetime_reschedule';
  }
  if (pageType === availabilityPageType) {
    type = 'datetime_selection';
  }
  return {
    page: {
      countryCode: channel.country.countryCode,
      language: channel.languageCode,
      channel: channel.code,
      channelType: channel.type,
      isTreatwellBrandedWidget: channel.type === 'widget',
      view,
      platformCode,
      type,
      gtmId: GTM_ID,
      environment: environment,
      channelEnvironment: `${channel.code}_${environment}`,
    },
    venue: {id: venueId},
  };
};
